<app-section-header [title]="'Tus propios eventos'" showStatusFilter="true" showViewMode="true" (viewMode)="setViewMode($event)" (statusFiltered)="setStatusFiltered($event)"></app-section-header>

<div class="section-wrapper">
    <sh-events-table [addEvent]="true" [events]="events" [title]="'Tus propios eventos'" [viewMode]="viewMode" [displayedColumns]="displayedColumns" (deleteEvent)="deleteEvent($event)" (deleteForeverEvent)="deleteForeverEvent($event)"></sh-events-table>
</div>
